module.exports = __webpack_public_path__ + "img/banner_z_l.16af00d8.jpg";